import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <div className="mx-auto mt-16 max-w-md text-center">
      <p className="bg-brand-gradient bg-clip-text text-6xl font-bold tracking-tight text-transparent">
        404
      </p>
      <p className="mt-3 text-2xl font-semibold tracking-tight">Page not found</p>
      <p className="text-muted-foreground mt-1 text-sm">Nothing lives at this address.</p>
      <Link
        to="/"
        className="text-brand-soft-foreground bg-brand-soft hover:bg-brand-soft/70 mt-6 inline-flex h-9 items-center rounded-lg px-4 text-sm font-medium transition-colors"
      >
        Back home
      </Link>
    </div>
  );
}
